import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { SubestatusService } from '@p-p-portafolio/services/subestatus.service';
import { SwalService } from '@shared/utils/swal.service';
import { SubestatusFormComponent } from './formaPago-form/subestatus-form.component';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-subestatus',
  templateUrl: './subestatus.component.html',
  styleUrls: ['./subestatus.component.css']
})
export class SubestatusComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayedColumns: Column[] = [
    { field: 'codigoEstado', header: 'Código Estado' },
    { field: 'codigoSubEstado', header: 'Código SubEstado' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'actions', header: 'Acciones' }
  ];

  private readonly _width: string = '1000px';
  public loading: boolean = true;
  public dataSource: any[] = [];
  private sEmpresa: string = '';
  private codigoEstado: string = '';

  constructor(
    public dialog: MatDialog,
    private subestatusService: SubestatusService,
    private swalService: SwalService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.sEmpresa = String(routeParams.get('sEmpresa'));
    this.codigoEstado = String(routeParams.get('codigoEstado'));
    this.read();
  }

  read() {
    this.loading = true;
    this.subestatusService.getAll(this.sEmpresa, this.codigoEstado).subscribe({
      next: (response) => {
        if (response) {
          this.dataSource = response;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar subestatus:', err);
        this.swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  openCreate() {
    const dialogRef = this.dialog.open(SubestatusFormComponent, {
      width: this._width,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.swalService.success('Registro creado correctamente');
        this.read();
      }
    });
  }

  openUpdate(model: any) {
    const dialogRef = this.dialog.open(SubestatusFormComponent, {
      width: this._width,
      data: model,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.swalService.success('Registro actualizado correctamente');
        this.read();
      }
    });
  }

  delete(model: any) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el subestatus ${model.codigoSubEstado}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.subestatusService.delete(model).subscribe({
          next: (response) => {
            if (response.success) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error('No se pudo eliminar');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
